module.exports = __webpack_public_path__ + "static/img/product_digitization_vx.bfbe6d5.svg";


//////////////////
// WEBPACK FOOTER
// ./static/img/product/product_digitization_vx.svg
// module id = BeLj
// module chunks = 0